import { useEffect } from "react";

const usePreventZoom = (allowZoom = false) => {
  useEffect(() => {
    const allowZooms = JSON.parse(localStorage.getItem("allowZoom"));
    if (allowZooms) return;
    let lastTouchEnd = 0;

    const handleTouchEnd = (e) => {
      const now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
      lastTouchEnd = now;
    };

    const handleGesture = (e) => {
      e.preventDefault();
    };

    const handleTouchMove = (e) => {
      if (e.touches.length > 1) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    };

    const handleDoubleClick = (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
    };

    const resetZoom = () => {
      document.body.style.transform = "scale(1)";
      document.body.style.transformOrigin = "top left";
      document.documentElement.style.zoom = "100%";
    };

    const detectZoomChange = () => {
      const zoomLevel = window.visualViewport.scale;
      if (zoomLevel !== 1) {
        resetZoom();
      }
    };

    document.documentElement.style.touchAction = "pan-y";
    document.documentElement.style.userSelect = "none";
    const options = { passive: false };
    document.addEventListener("touchend", handleTouchEnd, options);
    document.addEventListener("gesturestart", handleGesture, options);
    document.addEventListener("gesturechange", handleGesture, options);
    document.addEventListener("touchmove", handleTouchMove, options);
    document.addEventListener("dblclick", handleDoubleClick, options);
    window.visualViewport.addEventListener("resize", detectZoomChange);

    return () => {
      document.removeEventListener("touchend", handleTouchEnd);
      document.removeEventListener("gesturestart", handleGesture);
      document.removeEventListener("gesturechange", handleGesture);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("dblclick", handleDoubleClick);
      window.visualViewport.removeEventListener("resize", detectZoomChange);
      document.documentElement.style.touchAction = "";
      document.documentElement.style.userSelect = "";
    };
  }, [allowZoom]);
};

export default usePreventZoom;
